import { useMutation, useQuery } from "@apollo/client/react";
import paths from "config/routePaths";
import Site from "domain/Site";
import useApplicationContext from "hooks/apollo/applicationContext/useApplicationContext";
import { GetAllCompanies } from "hooks/apollo/company/company.gql";
import { CreateSite, GetAssignedSites } from "hooks/apollo/site/site.gql";
import { GetAllTimeZones } from "hooks/apollo/timeZone/timeZone.gql";
import useGoBack from "hooks/useGoBack";
import React, { useState } from "react";
import Uuid from "utils/Uuid";
import SiteEditView from "./SiteEditView";

export default function SiteCreateContainer({ companyId }) {
  const { goBack } = useGoBack();
  const applicationContext = useApplicationContext();
  const { nulogyAdmin } = applicationContext;

  const { data: companiesData, loading: companiesLoading } = useQuery(GetAllCompanies);
  const { data: timezoneData, loading: timezonesLoading } = useQuery(GetAllTimeZones);
  const [error, setError] = useState(false);
  const leavePage = () => {
    goBack(paths.siteIndex);
  };
  const [createSite] = useMutation(CreateSite, { onCompleted: () => leavePage() });

  if (timezonesLoading || companiesLoading) return null;

  const handleCancel = () => leavePage();

  const handleSave = (args) => {
    const site = { id: Uuid.generate(), ...args, companyId: args.company?.id };

    return createSite({ refetchQueries: [{ query: GetAssignedSites }], variables: site });
  };

  return (
    <SiteEditView
      companies={companiesData?.companies || []}
      companyId={companyId}
      error={error}
      nulogyAdmin={nulogyAdmin}
      onCancel={handleCancel}
      onSave={handleSave}
      setError={setError}
      site={Site.build()}
      timeZones={timezoneData?.timeZones}
    />
  );
}
